import { createTheme } from "@material-ui/core/styles";

const createCustomTheme = (headerColor, color) =>
  createTheme({
    overrides: {
      MUIDataTable: {
        paper: {
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        },
      },
      MUIDataTableToolbar: {
        root: {
          backgroundColor: headerColor,
          borderTopLeftRadius: 4,
          borderTopRightRadius: 4,
          color: color,
        },
        icon: {
          color: color,
        },
      },
      MUIDataTableHeadCell: {
        fixedHeader: {
          backgroundColor: "#f1f1f1",
          color: "black",
          fontWeight: "bold",
          whiteSpace: "nowrap", // Garder l'espace blanc nowrap pour les cellules de tête
        },
      },
      MUIDataTableBodyCell: {
        root: {
          "&:nth-of-type(1)": {
            whiteSpace: "nowrap", // Garder l'espace blanc nowrap pour la première colonne
          },
          "&:nth-of-type(n+2)": {
            whiteSpace: "normal", // Permettre le retour à la ligne pour les autres colonnes
          },
        },
      },
      MUIDataTableBodyRow: {
        root: {
          "&:nth-of-type(odd)": {
            backgroundColor: "#fafafa",
          },
          "&:nth-of-type(even)": {
            backgroundColor: "#ffffff",
          },
          "&:hover": {
            backgroundColor: "#e0e0e0",
          },
        },
      },
    },
  });

export default createCustomTheme;
